export enum enumGATagEventAction {
  CompanyValidateISF = 'Validate from ISF',
  CompanyValidateES = 'Validate from ES',
  CompanyValidateLCL = 'Validate from LCL',
  CompanyValidateCompanyPage = 'Validate from CompanyPage',
  CompanyValidateAnnualBond = 'Validate from Annual Bond',

  IsfCreate = 'Isf create',
  IsfView = 'Isf view',
  ESCreate = 'Create from Scratch',
  ESCreateFromIsf = 'Create from isf',
  ESDuplicate = 'Duplicate',
  ESDelete = 'Delete',
  ESFreightType = 'Freight type',
  ESCalcStart = 'Calculate',
  ESCalcComplete = 'Calculation Complete',
  ESCalcError = 'Calculation Error',
  EezyFreightGetQuote = 'Get a Quote',
  EezyFreightGetManualQuote = 'Get a Quote Manual',
  EezyFreightBookNow = 'Book Now',
  EezyFreightPlaceOrder = 'Place order',
  EezyFreightSelectedRoute = 'Selected route',
  SignUp = 'SignUp',
  SignIn = 'SignIn',
  SkipProfile = 'Skip Profile',
  UshipHint = 'Powered by uShip',
  UshipGetQuote = 'Get a quote',
  DripHint = 'Learn more about Drip Capital',
  DripLearnMore = 'Learn more',
  DripGetStarted = 'Get started',
  OBFilerCodeRequest = 'Filer Code Request',
  OBAbaProfileRequest = 'Abi Profile Request',
  OBAahMethodRequest = 'ACH Method Request',
  OBFilerCodeUpdateInfo = 'Filer Code Update',
  OBPermittedPortsUpdateInfo = 'Permitted Approved Ports Update',
  OBMainPortUpdateInfo = 'Main Port Update',
  OBAbiProfileUpdateInfo = 'Abi Profile Update',
  OBAchMethodUpdateInfo = 'ACH Method Update',
  GadgetGod = 'Gadget God',
}
